import React from 'react';
import withLoading from '../../../hoc/Loading';

type Props = {
	children: JSX.Element | JSX.Element[];
};

const Account: React.FunctionComponent<Props> = ({ children }) => {
	return <div>{children}</div>;
};

export default withLoading(Account);
